module.exports = __webpack_public_path__ + "account/img/187.042f6098.png";